import { useState } from 'react';
import classNames from 'classnames/bind';
import { MochiCarousel } from '../..';
import styles from './mochi-parking-tutorial-carousel.module.sass';
import Lottie from 'react-lottie';
import { PARKING_TUTORIAL_VERTICAL_LIST_DATA } from '../../const';

const cx = classNames.bind(styles);

interface MochiParkingTutorialCarouselProps {
  isPlay?: boolean;
  parkingServiceType: 'autopass';
}

export const MochiParkingTutorialCarousel = ({
  isPlay,
  parkingServiceType,
}: MochiParkingTutorialCarouselProps) => {
  const [index, setIndex] = useState<number>(0);
  const list = PARKING_TUTORIAL_VERTICAL_LIST_DATA[parkingServiceType];

  return (
    <MochiCarousel
      onSlideChange={(index) => setIndex(index)}
      items={list.map(({ lottie, content, id }, i) => (
        <div className={cx('item-container')} key={id}>
          <Lottie
            isStopped={isPlay && i !== index}
            options={{
              animationData: lottie,
              loop: true,
              autoplay: true,
            }}
          />
          <p className={cx('item-content')}>{content}</p>
        </div>
      ))}
    />
  );
};
